import Vue from 'vue';
import Vuex from 'vuex';
import { vuexfireMutations } from 'vuexfire';

import admin from './modules/admin';
import app from './modules/app';
import auth from './modules/auth';
import challengeAttempts from './modules/challengeAttempts';
import challenges from './modules/challenges';
import concepts from './modules/concepts';
import conceptAttempts from './modules/conceptAttempts';
import dailyChallenges from './modules/dailyChallenges';
import con, { mutationTypes } from './mutationTypes';
import classes from './modules/classes';
import flows from './modules/flows';
import functions from './modules/functions';
import groups from './modules/groups';
import groupDeepLinks from './modules/groupDeepLinks';
import images from './modules/images';
import notificationSettings from './modules/notificationSettings';
import orders from './modules/orders';
import questions from './modules/questions';
import systemSettings from './modules/systemSettings';
import tests from './modules/tests';
import topics from './modules/topics';
import relatedConcepts from './modules/relatedConcepts';
import users from './modules/users';
import versionedConcepts from './modules/versionedConcepts';
import videos from './modules/videos';

Vue.use(Vuex);

// Register mutations for loader state here before using them
mutationTypes.addModule('loader');
mutationTypes.add('loader', ['LOADING_INIT', 'LOADING_DONE']);

const loader = {
  state: {
    active: false
  },
  mutations: {
    [con.LOADING_INIT](state) {
      state.active = true;
    },

    [con.LOADING_DONE](state) {
      state.active = false;
    }
  }
};

const store = new Vuex.Store({
  modules: {
    admin,
    app,
    auth,
    challengeAttempts,
    challenges,
    concepts,
    conceptAttempts,
    classes,
    dailyChallenges,
    flows,
    functions,
    groups,
    groupDeepLinks,
    images,
    notificationSettings,
    orders,
    questions,
    loader,
    systemSettings,
    tests,
    topics,
    relatedConcepts,
    users,
    versionedConcepts,
    videos
  },
  mutations: {
    ...vuexfireMutations
  }
});

export default store;
